export default "__VITE_ASSET__4fdb914b__"